module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3aHv1"))).then(() => module.bundle.root('fThBo'));